import axios from 'axios';

const cincoAPI = axios.create({
    baseURL: process.env.REACT_APP_URL_CINCO+'/cinco/modelo/'
});



export default cincoAPI;